interface NumberOptions {
  round?: number
}

interface ArrayOptions {
  flatten?: boolean
}

class DataType {
  public static boolean(value?: string | number | boolean | null) {
    if (typeof value === 'undefined' || value === null) {
      return false
    }

    return Number(value) === 1 || value === 'true' || value === true
  }

  public static string(value: any): string {
    if (typeof value === 'undefined' || value === null || typeof value === 'object') {
      return ''
    }

    return value.toString()
  }

  public static array<T>(value: T[] | T[][], options?: { flatten: true }): T[]
  public static array<T>(value: T[] | null | undefined, options?: { flatten?: false }): T[]
  public static array<T = any>(value: unknown, options?: ArrayOptions): T[]

  public static array<T>(value: unknown, options?: ArrayOptions): T[] {
    if (!Array.isArray(value)) {
      return []
    }

    let outputArray = value as T[]

    if (options?.flatten) {
      outputArray = (outputArray as any[]).flat() as T[]
    }

    return outputArray
  }

  public static number(value?: any, options?: NumberOptions) {
    if (typeof value === 'undefined' || value === null || isNaN(Number(value)) || isNaN(value)) {
      return 0
    }

    let outputNumber = Number(value)

    if (options?.round) {
      outputNumber = Number(outputNumber?.toFixed(options?.round))
    }

    return outputNumber
  }
}

export { DataType }
